import { render, staticRenderFns } from "./wyModalEditSignature.vue?vue&type=template&id=2fade0ec&"
import script from "./wyModalEditSignature.vue?vue&type=script&lang=js&"
export * from "./wyModalEditSignature.vue?vue&type=script&lang=js&"
import style0 from "./wyModalEditSignature.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports